import React from 'react';
import { ActionDot } from './ActionDot';
import { PhotoPlaceholder } from '../core/PhotoPlaceholder';

export function DishRow({
  photo,
  type,
  name,
  time,
  source,
  status = 'pending',
  selected = false,
  onNameClick,
  onApprove,
  onReject,
  showActions = true,
}) {
  const rowClass = [
    'ds-dish-row',
    status === 'approved' ? 'ds-dish-row--approved' : '',
    status === 'rejected' ? 'ds-dish-row--rejected' : '',
    selected ? 'ds-dish-row--selected' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rowClass}>
      <div className="ds-dish-row__bar" aria-hidden />
      <div className="ds-dish-row__photo">
        {photo ? (
          <img src={photo} alt={name} className="ds-dish-row__photo-img" />
        ) : (
          <PhotoPlaceholder label="" hint="" height={72} radius={4} />
        )}
        {type ? <span className="ds-dish-row__type-badge">{type}</span> : null}
      </div>
      <div className="ds-dish-row__body">
        <button
          type="button"
          className="ds-dish-row__name"
          onClick={onNameClick}
          disabled={!onNameClick}
        >
          {name}
        </button>
        <div className="ds-dish-row__meta">
          {time ? <span className="ds-dish-row__time">{time}</span> : null}
          {source ? <span className="ds-dish-row__source">{source}</span> : null}
        </div>
      </div>
      {showActions ? (
        <div className="ds-dish-row__actions">
          <ActionDot tone="approve" active={status === 'approved'} onClick={onApprove}>
            ✓
          </ActionDot>
          <ActionDot tone="reject" active={status === 'rejected'} onClick={onReject}>
            ✕
          </ActionDot>
        </div>
      ) : null}
    </div>
  );
}

export default DishRow;
